import { render, staticRenderFns } from "./scroll-pane.vue?vue&type=template&id=f791864c"
import script from "./scroll-pane.vue?vue&type=script&lang=js"
export * from "./scroll-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports